import { Injectable } from '@angular/core';
import { Http, Response } from '@angular/http';
import { Headers, RequestOptions } from '@angular/http';
import { Observable } from 'rxjs/Observable';

import { BaseWebService } from "../../shared/services/base-web.service";
import { SessionStorageService } from "../../shared/services/session-storage.service";
import { TranslateService } from '../../translate/translate.service';
import 'rxjs/add/observable/throw';

@Injectable()
export class SharedService {
    constructor(
        private _basewebservice: BaseWebService,
        private _sessionStorageService: SessionStorageService,
        private _translate: TranslateService
    ) { }

    checkEmailPermit(emailData: any) {
        const data: any = {};
        data.body = emailData;
        return this._basewebservice.request("v1/email_permit/", "post", data)
            .map((res: any) => res)
            .catch(this.handleError);
    }

    /**
     * Service function for Treatment Group
     */
    getTreatmentGroup() {
        return this._basewebservice.request("v1/treatment_groups/", "get", )
            .map(res => res)
            .catch(this.handleError);
    }

    /**
     * Service function for Treatment Category
     */
    getTreatmentListCategory() {
        return this._basewebservice.request("v1/treatment_category_list/", "get", )
            .map(res => res)
            .catch(this.handleError);
    }

    /**
     * Service function for Treatment Options
     */
    getTreatmentOptions() {
        return this._basewebservice.request("v1/treatment_options/", "get", )
            .map(res => res)
            .catch(this.handleError);
    }

     /**
     * Service function for Treatment Options
     */
    getTreatmentOptionsWithCustom() {
        return this._basewebservice.request("v1/treatment_options/?include_custom=" + true, "get", )
            .map(res => res)
            .catch(this.handleError);
    }

    setTranslateLanguage() {
        this._sessionStorageService.readItem('language').then((data: any) => {
            if(data) {
                this._translate.use(data.lang);
            } else {
                this._translate.use('en');
            }
	    });
    }

    /**
     * Function to get tx_plan details from api.
     * @param  {any} id contains tx_plan id.
     */
    getTreatmentPlan(id: any) {
        return this._basewebservice.request("v1/treatment_plan/" + id + "/", "get")
            .map((res: any) => res)
            .catch(this.handleError);
    }

    /**
   * Function for handling service call errors
   * @param  {Response|any} error contains error data
   */
    handleError(error: Response | any) {
        return Observable.throw(error);
    }

    resendEmailVerification(userId:any){
        const data: any = {};
        return this._basewebservice.requestFormData("v1/user/" + userId + "/ses_verification/", "post", data)
        .map((res: any) => res)
        .catch(this.handleError);
    }

    resendFcEmailVerification(userId:any){
        const data: any = {};
        return this._basewebservice.requestFormData("v1/user/" + userId + "/fc_ses_verification/", "post", data)
        .map((res: any) => res)
        .catch(this.handleError);
    }

}